import RestModel from './RestModel';
import removeExtraSubFieldsHelper from '../helpers/removeExtraSubFieldsHelper';

const resourceName = 'social-network-links';

export default {
    create: resource => RestModel.create(resourceName, removeExtraSubFieldsHelper(resource, ['socialNetwork'])),

    edit: resource => RestModel.edit(resourceName, removeExtraSubFieldsHelper(resource, ['socialNetwork'])),

    list: () => RestModel.list(resourceName),

    read: id => RestModel.read(resourceName, id),

    remove: id => RestModel.remove(resourceName, id),
};
